module.exports = __webpack_public_path__ + "img/thumbnail-cover.ee368d50.jpg";